import styled from '@emotion/styled';
import { Button, TableContainer } from '@ui-components/neo.tax';

export const StyledButton = styled(Button)({
  margin: 0,
});

export const StyledTableContainer = styled(TableContainer)<{ disabled?: boolean }>({}, ({ disabled }) => ({
  opacity: disabled ? 0.3 : 1,
}));
